// https://github.com/devcode-git/BamboraBankClient/blob/master/src/api/httpClient.js
import Axios from 'axios'
import { RequestPayload } from 'types'
const qs = require('qs')

// If this is toggled to true, CORS-problems occurs locally
// Axios.defaults.withCredentials = true

const request = (payload: RequestPayload): any => {
  const { method, url, data, params, headers } = payload
  return Axios.request({
    method,
    url,
    data,
    params,
    headers
  })
}

export const del = (url: string, data = {}, params = {}, headers = {}): any => {
  return request({
    method: 'DELETE',
    url,
    data,
    params,
    headers
  })
}

// Get request + adds the token saved in store as url-param
export const get = (url: string, params: Object, headers: Object): any => {
  return request({
    method: 'GET',
    url,
    data: {},
    params,
    headers
  })
}

// post request + adds the token saved in store as url-param
export const patch = (url: string, payload = {}, params = {}, headers = {}): any => {
  return request({
    method: 'PATCH',
    url,
    data: payload,
    params,
    headers
  })
}

// post request + adds the token saved in store as url-param
export const post = (url: string, payload = {}): any => {
  return request({
    method: 'POST',
    url,
    data: payload,
    params: {},
    headers: {}
  })
}

export const put = (url: string, data = {}, headers = {}): any => {
  return request({
    method: 'PUT',
    url,
    data,
    params: {},
    headers
  })
}
